import { fromJS } from 'immutable';

import type { TypedMap } from 'utils/typed-map';

import {
  INIT,
  INIT_SUCCESS,
  INIT_FAILED,
  SAVE_FAILED,
  INCREMENT_STEPPER,
  SET_STEPPER,
  FILE_UPLOADED,
  FETCH_PARTNERS,
  FETCH_PARTNERS_SUCCESS,
  FETCH_PARTNERS_FAILED,
} from './constants';
import type { DeedFormPageActions } from './actions';

export type DeedFormState = TypedMap<{
  loading: boolean;
  partnersLoading: boolean;
  activeStep: number;
  uploadedFile: string | null | undefined;
  errorCode: number | null | undefined;
}>;

export const initialState: DeedFormState = fromJS({
  loading: false,
  partnersLoading: false,
  activeStep: 0,
  uploadedFile: null,
  errorCode: null,
});

function deedFormPageReducer(state = initialState, action: DeedFormPageActions): DeedFormState {
  switch (action.type) {
    case INIT:
      return state.merge({ loading: true, uploadedFile: null });

    case INIT_SUCCESS:
      return state.set('loading', false);

    case INIT_FAILED:
      return state.merge({ loading: false, errorCode: action.errorCode });

    case SAVE_FAILED:
      return state.merge({ errorCode: action.errorCode });

    case INCREMENT_STEPPER:
      return state.set('activeStep', state.get('activeStep') + 1);

    case SET_STEPPER:
      return state.set('activeStep', action.step);

    case FILE_UPLOADED:
      return state.set('uploadedFile', action.file.publicUrl);

    case FETCH_PARTNERS:
      return state.set('partnersLoading', true);

    case FETCH_PARTNERS_SUCCESS:
      return state.set('partnersLoading', false);

    case FETCH_PARTNERS_FAILED:
      return state.set('partnersLoading', false);

    default:
      return state;
  }
}

export default deedFormPageReducer;
